type HeadingLevel = "paragraph" | 1 | 2 | 3

type EditorHeadingSelectProps = {
  value: HeadingLevel
  disabled?: boolean
  onChange: (level: HeadingLevel) => void
}

const OPTIONS: { value: HeadingLevel; label: string }[] = [
  { value: "paragraph", label: "Paragraph" },
  { value: 1, label: "Heading 1" },
  { value: 2, label: "Heading 2" },
  { value: 3, label: "Heading 3" },
]

const EditorHeadingSelect = ({
  value,
  disabled = false,
  onChange,
}: EditorHeadingSelectProps) => {
  return (
    <select
      className='tiptap-editor__heading-select'
      value={String(value)}
      disabled={disabled}
      aria-label='Text style'
      title='Text style'
      onChange={(event) => {
        const next = event.target.value
        onChange(next === "paragraph" ? "paragraph" : (Number(next) as 1 | 2 | 3))
      }}
    >
      {OPTIONS.map((option) => (
        <option key={String(option.value)} value={String(option.value)}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default EditorHeadingSelect
